import {hot} from 'react-hot-loader/root'
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ImageList  from 'shared/ImageList'
import CreatableSelect from 'react-select/lib/Creatable';
import RemoveModalDialog from'shared/RemoveModalDialog';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {v4 as uuidv4}  from 'uuid'
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList, hexToBase64,base64ToHex, deleteImagesFromS3} from 'util/Utils';
import AdminQualityChecksListTable from 'dashboard/qualityChecks/AdminQualityChecksListTable';
import AdminQualityChecksSearchBox from 'dashboard/qualityChecks/AdminQualityChecksSearchBox'
import QualityCheckAnswerList from 'dashboard/qualityChecks/components/QualityCheckAnswerList';
import config from  '../../../config';
import _ from 'lodash';




class AdminQualityChecksPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            errors: {},
            sortBy: '',
            allCategories: [],

            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            currentRecord:{},
            qualityChecks:{
                 data: [],
                fetched:false,
                total:0
            }
        };
        console.log('quality checks'   );
        this.searchBox = null
    };

    componentWillMount() {
        this.props.makeRequest({}, {
            'endpoint': '/categories',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allCategories: response.data.data,
                currentRecordCategoriesList: _.map(prepareSelectOptionsList(
                    _.filter(response.data.data, function (category) {
                        return category.AncestorCategories.length == 0
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id',
                    }), function (item) {
                    return {value: uuidv4(), originalID: item.value, label: item.label}
                })

            })

        })
        this.props.makeRequest({'type': 'CategoryTagsList'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allCategoryTags: _.map(_.get(response.data, 'data', []).sort(), item => {
                    return {'value': item, 'label': item}
                })
            })
        }).catch(err => {
        });

        this.props.makeRequest({'type': 'getAllBrandsWithModels'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            console.log('response getAllBrandsWithModels', response    );
            this.setState({

                allBrandsWithModels: _.orderBy(_.map(_.get(response.data, 'data', []), item => {
                    return {'value': item.Brand, 'label': item.Brand, Models:item.Models}
                }), 'label', 'asc')
            })
        }).catch(err => {
        });
    }
    componentDidMount() {
        const addScript = document.createElement('script');
        addScript.setAttribute('src', 'https://cdn.ckeditor.com/4.7.3/standard/ckeditor.js');
        document.body.appendChild(addScript);
     }
    initializeCKeditor() {
        const self = this;
        self.removeCKeditor();
        let configuration = {
            toolbar: 'Basic',
            allowedContent: true,
            entities:false,
            fillEmptyBlocks:false,
            tabSpaces:0,
            extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*}'
        };
        CKEDITOR.replace('editor', configuration);
        CKEDITOR.instances.editor.on('change', function () {
            const data = CKEDITOR.instances.editor.getData();
            self.setState({
                currentRecord: {
                   ...self.state.currentRecord,
                    CustomHTML:data
                }});
        });
    }
    removeCKeditor() {
        const {instances = {}} = window.CKEDITOR || {};
        const {editor} = instances;
        if(editor) {
            CKEDITOR.instances.editor.destroy();
        }
    }
    setCkeditorValue(body) {
         CKEDITOR.instances.editor.setData(body);
    }
    addNewRecord() {
        const newRecordID = uuidv4()
        console.log('newRecordID', newRecordID  );
        const idInBase64 = hexToBase64(newRecordID)
        console.log('idInBase64', idInBase64  );
        this.setState({
            showModal: true,
            currentRecord: {
                _id:hexToBase64(newRecordID),
                newRecordID:newRecordID,
                QualityCheckImages:[],
                Categories: [],
                CategoryTags:[],
                Models:[],
                Status:'Active',
                Text: '',
                MatchingType: 'Matching',
                IsSerialNumber: false
            },

        });
    }

    editRecord(row) {
        const self = this;
        const {DeterministicQualityCheck = {}} = row;
        _.forEach(_.get(row, ['Models'], []), function (storedModel) {
           storedModel.value = uuidv4()
        })
        var availableCategories = [];

        _.forEach(_.get(row, ['Categories'], []), function (savedCategory) {
            console.log('savedCategory', savedCategory  );
             var foundCategory = _.find(this.state.allCategories, function (category) {
                return category.AncestorCategories.length == 0 && savedCategory.Category == category.TagName
            }.bind(this))

            var foundSubcategory = _.find(this.state.allCategories, function (category) {
                return category.AncestorCategories.length > 0 && savedCategory.Subcategory == category.TagName
            }.bind(this))
            console.log('foundCategory', foundCategory ,foundSubcategory );
            if (foundCategory && (!savedCategory.Subcategory || foundSubcategory)) {
                availableCategories.push({...savedCategory, originalID: foundCategory._id, value: uuidv4()})
            }
        }.bind(this))
        var lastCategory = _.last(availableCategories)
        var foundCategory = _.find(this.state.allCategories, function (category) {
            return category.AncestorCategories.length == 0 && lastCategory && lastCategory.Category == category.TagName
        }.bind(this))
        var foundSubcategory = _.find(this.state.allCategories, function (category) {
            return category.AncestorCategories.length > 0 && lastCategory && lastCategory.Subcategory == category.TagName
        }.bind(this))
        if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), foundCategory._id)) {
            foundSubcategory = undefined;
        }
        var currentRecordSubcategoriesList = [];
        if (foundCategory) {
            currentRecordSubcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.state.allCategories, function (category) {
                    return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), foundCategory._id)
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label')
        }
        this.setState({
            currentRecordModelsList:  [],
            showModal: true,
            currentRecord: {
                ...row,
                useCustomHTML:row.CustomHTML ? true : false,
                CategoryTags: _.map(row.CategoryTags, function (tag) {
                    return {value: tag, label: tag};
                }),
                SellerInventoryOwnership:_.map(_.get(row,'SellerInventoryOwnership',[]), function (item) {
                   return _.find(config.inventoryOwnershipMap,{value:item})
                }),
                OverrideMatchingConditions: _.get(row,'OverrideMatchingConditions.0.Type') ? true:false,
                SearchCPSC: _.isUndefined(_.get(row,'QualityCheckActions.0.ActionName'))?undefined :_.get(row,'QualityCheckActions.0.ActionName') =='SearchCPSC' ? true:false,
                GBGProductTags: _.map(row.GBGProductTags, function (tag) {
                    var foundGBGProductTag = _.find(self.state.allGBGProductTags, item=>{
                        return  item.value == tag
                    })
                    if(foundGBGProductTag) {
                        return {value: foundGBGProductTag.value, label: foundGBGProductTag.label};
                    } else{
                        return {value: tag, label: tag};
                    }
                }),
                Categories: availableCategories,
             },

        },()=>{
                 if (self.state.currentRecord.useCustomHTML) {
                  self.initializeCKeditor();
                  self.setCkeditorValue(row.CustomHTML);
                }
        });
    }
    renderCategoriesValue(option) {
        return (
            <div>
                <div>{option.Category}</div>
                <div>{option.Subcategory}</div>
            </div>
        );
    }

    onModelFormChange(option) {
        console.log('onModelFormChange', option);



            this.setState({
                'currentRecord': {
                    ...this.state.currentRecord,
                    Models: [...this.state.currentRecord.Models.slice(0, _.size(this.state.currentRecord.Models) - 1),
                        {..._.last(this.state.currentRecord.Models), Model:   option.value },
                        ...this.state.currentRecord.Models.slice(_.size(this.state.currentRecord.Models))],
                }
            })
        }


    onBrandFormChange(options) {
        console.log('onBrandFormChange', options);

        var clearModelValue = false,   modelOptions = []
        var Models = [...this.state.currentRecord.Models]
        console.log('last', _.last(options));

         console.log('length', options.length, Models.length);
        if (options.length > Models.length) { /* when new option is selected */
            modelOptions = _.get(_.last(options), 'Models', [])
            Models.push({
                 Models:  _.last(options).Models,
                Brand:  _.last(options).value,
            })

        } else if (options.length < Models.length) { /* value is removed */
            _.forEach(this.props.allBrandsWithModels, function (record) {
                modelOptions = _.concat(modelOptions, record.Models)
            })
            var deletedOption = _.differenceWith(Models, options, function (item1, item2) {
                return ( item1.Brand === item2.Brand && item1.value === item2.value && ((!item1.Model && !item2.Model) || item1.Model === item2.Model))

            });
            /* returns difference between first   and second arrays*/
console.log('deletedOption', deletedOption  );
            _.remove(Models, function (item) {
                if (item.Brand == deletedOption[0].Brand && item.Model == deletedOption[0].Model){
                    return true;
                }
            })
            console.log('after remove', Models);

        }



            var currentRecordModelsList = _.sortBy(prepareSelectOptionsList(
                _.map(modelOptions,model=>{
                    return {label:model, value:model}}),
                {
                    label: 'label',
                    value: 'value'
                }), 'label')
console.log('currentRecordModelsList', currentRecordModelsList  );

        this.setState({
            currentRecordModelsList: currentRecordModelsList,
            Model: clearModelValue ? '' : this.state.Model,
            'currentRecord': {
                ...this.state.currentRecord,
                Models: Models,

            },
            // currentRecordCategoriesList: _.map([...this.state.currentRecordCategoriesList], function (item) {
            //     return {value: uuidv4(), originalID: item.originalID, label: item.label}
            // })
        })

    }
    validateAndGetFormData() {
        let formData = _.pick(this.state.currentRecord, ['Status',  'Text',   'MatchingType', 'Categories', 'Models', 'IsSerialNumber']);
        let dataNotValid = false;

        _.forEach([ 'Text'], function (requiredField) {
            if (formData[requiredField] == '') {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': requiredField + ' field is required',
                });
                dataNotValid = true;
                return false;
            }
        }.bind(this))
        formData.DeterministicQualityCheck  = _.cloneDeep(this.state.currentRecord.DeterministicQualityCheck || {});
        const {Answers = []} = formData.DeterministicQualityCheck;
         Answers.forEach(answer =>{
            if (answer.Penalty && (isNaN(answer.Penalty) || answer.Penalty > 100 || answer.Penalty <= 0)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': `Answer penalty number ${answer.Penalty}  is not valid`
                });
                dataNotValid = true;
            }

            if(answer.Penalty == '') {
                delete answer.Penalty;
            }
        });
        formData['CategoryTags'] =  _.map(_.get(this.state.currentRecord,  'CategoryTags', []), 'value')
        if (this.state.currentRecord.Rules && !_.isObject(this.state.currentRecord.Rules)){
            try {
                formData.Rules = JSON.parse(this.state.currentRecord.Rules)
                if (!_.isObject(  formData.Rules)){
                    throw false ;
                }
            } catch (e) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Can not parse JSON string for Rules',
                });
            }
            formData.Rules = JSON.parse(this.state.currentRecord.Rules)
        }

        formData.CustomHTML = '';
         if(this.state.currentRecord.useCustomHTML) {
             formData.CustomHTML = this.state.currentRecord.CustomHTML;
        }
        formData['SellerInventoryOwnership'] =  _.map(_.get(this.state.currentRecord, 'SellerInventoryOwnership', []), 'value')
        if ( formData['SellerInventoryOwnership'].length && _.get(this.state.currentRecord,  'OverrideMatchingConditions', false)) {
            formData.OverrideMatchingConditions =  [{Type:'SellerInventoryOwnership'}]
        }else{
            formData.OverrideMatchingConditions =[]
        }
        if ( !_.isUndefined(this.state.currentRecord,  'SearchCPSC')) {
            if (this.state.currentRecord.SearchCPSC) {
                formData.QualityCheckActions =  [{ActionName:'SearchCPSC'}]
            }else{
                formData.QualityCheckActions =[]
            }
        }

        if (dataNotValid) {
            return false;
        }
        return formData
    }

    saveRecord() {
        var formData = this.validateAndGetFormData();
         if (!formData) {
            return false;
        }
        var methodData
        if (this.state.currentRecord.newRecordID) {
            formData.QualityCheckImages = this.state.currentRecord.QualityCheckImages
            formData._id = this.state.currentRecord.newRecordID
            methodData = {
                "endpoint": "/quality-checks",
                type: "post",
                messageData: {'#1#': 'Quality Check'},
                messageCode: 'recordAdded'
            };
        } else {
            methodData = {
                "endpoint": "/quality-checks/" + encodeURIComponent(this.state.currentRecord._id),
                type: "patch",
                messageData: {'#1#': 'Quality Check'},
                messageCode: 'recordUpdated'
            };
        }

        this.props.makeRequest(formData, methodData).then(res => {
            this.setState({
                showModal: false,
                currentRecord: {},
            })
            this.search({page:this.state.currentPage+1})
        }).catch(err => {
        });

    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }








    onSortChange(field, sort) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sort == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        console.log('params', params  );
         if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'createdAt:-1';
        }
        if (queryParams.page === 1) {
            delete queryParams.page;
        }
        var methodData = {
            "endpoint": "/quality-checks",
            'not_display_success_message': true,
         };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['Brands', 'Models', 'ItemNumbers']));
            this.context.router.push('/admin/quality-checks?' + stringified);
        }

        const {openEditForm = false} = this.props.location && this.props.location.query ? this.props.location.query : {};

        return this.props.makeRequest(queryParams, methodData).then(res => {
          this.setState({
              currentPage:_.isUndefined(queryParams.page) ?0:queryParams.page,
              qualityChecks:{
                data:res.data.data,
                  total:res.data.total,
                  fetched:true,
            }})

            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                 this.refs.pagination.resetPagination();
            }

            if(openEditForm && res.data.data.length == 1) {
                this.editRecord(res.data.data[0]);
            }
        }).catch(err => {
        });
    }
    onSubcategoryFormChange(option) {
        console.log('option', option);
        var lastSelectedCategory = _.find(this.state.allCategories, function (category) {
            return _.last(this.state.currentRecord.Categories).originalID == category._id
        }.bind(this))
        var foundSubcategory = _.find(this.state.allCategories, function (category) {
            return category.AncestorCategories.length > 0 && option.value == category._id
        }.bind(this))
        console.log('lastSelectedCategory', lastSelectedCategory, foundSubcategory);
        if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)) {
            foundSubcategory = undefined;
        }
        if (foundSubcategory) {
            this.setState({
                'currentRecord': {
                    ...this.state.currentRecord,
                    Categories: [...this.state.currentRecord.Categories.slice(0, _.size(this.state.currentRecord.Categories) - 1),
                        {..._.last(this.state.currentRecord.Categories), Subcategory: foundSubcategory.TagName},
                        ...this.state.currentRecord.Categories.slice(_.size(this.state.currentRecord.Categories))],
                }
            })
        }


    }
    onCategoryFormChange(options) {
        console.log('option', options);
        var clearSubcategoryValue = false;
        var Categories = [...this.state.currentRecord.Categories]
        var lastSelectedCategory = _.find(this.state.allCategories, function (category) {
            return _.last(options) && _.last(options).originalID == category._id
        }.bind(this))
        // console.log('length', options.length,Categories.length  );
        if (options.length > Categories.length) { /* when new option is selected */
            Categories.push({
                ... _.last(options),
                value: uuidv4(),
                Category: lastSelectedCategory.TagName,
                originalID: _.last(options).originalID
            })

        } else if (options.length < Categories.length) { /* value is removed */
            var deletedOption = _.differenceWith(Categories, options, function (item1, item2) {
                return ( item1.Category === item2.Category && item1.value === item2.value && ((!item1.Subcategory && !item2.Subcategory) || item1.Subcategory === item2.Subcategory))
            });
            /* returns difference between first   and second arrays*/

            _.remove(Categories, function (item) {
                if (item.Category == deletedOption[0].Category && ((!item.Subcategory && !deletedOption[0].Subcategory) || item.Subcategory === deletedOption[0].Subcategory)) {
                    return true;
                }
            })
            console.log('after remove', Categories);

        }
        console.log('lastSelectedCategory', lastSelectedCategory);
        if (lastSelectedCategory) { /* change options for Subcategories */

            var currentRecordSubcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.state.allCategories, function (category) {
                    return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label')
            /* check if currently selected subcategory belongs to the selected category*/
            if (this.state.Subcategory) {
                var foundSubcategory = _.find(this.state.allCategories, function (category) {
                    return this.state.Subcategory == category._id
                }.bind(this))
                if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)) {
                    clearSubcategoryValue = true;
                }
            }

        }

        this.setState({
            currentRecordSubcategoriesList: currentRecordSubcategoriesList,
            Subcategory: clearSubcategoryValue ? '' : this.state.Subcategory,
            'currentRecord': {
                ...this.state.currentRecord,
                Categories: Categories,

            },
            currentRecordCategoriesList: _.map([...this.state.currentRecordCategoriesList], function (item) {
                return {value: uuidv4(), originalID: item.originalID, label: item.label}
            })
        })

    }
    removeRecord() {
        var self = this
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/quality-checks/" + encodeURIComponent(this.state.currentRecord._id),
            messageData: {'#1#': 'Quality check'},
            messageCode: 'recordDeleted',
        };
        this.setState({currentRecord: {}});
        this.props.makeRequest({}, methodData).then(function () {
            self.search()
        }).catch(err => {

        });
    }
    deleteImage(imageToDelete, params={}) {
        let promise
        if(this.state.currentRecord.newRecordID){
              promise = deleteImagesFromS3.call(this, [imageToDelete.URL])
        } else {
            promise = this.props.makeRequest({QualityCheckImagesToDelete: [imageToDelete]}, {
                "endpoint": "/quality-checks/" + encodeURIComponent(this.state.currentRecord._id),
                type: "patch",
            })
        }
        return promise.then(res => {
            const {QualityCheckImages = [],imagesToDelete = []} = this.state.currentRecord
            var imageToDeleteIndex = QualityCheckImages.findIndex(item=>item._id == imageToDelete._id);
            this.setState({
                currentRecord: {
                    ...this.state.currentRecord,
                    imagesToDelete: imagesToDelete.concat([imageToDelete.URL]),
                    QualityCheckImages: [...QualityCheckImages.slice(0, imageToDeleteIndex),
                        ...QualityCheckImages.slice(imageToDeleteIndex + 1)],
                }
            })
            if(!params.doNotDisplayMessage) {
                this.props.displayMessage({
                    'messageCode': 'Image deleted',
                });
            }
            this.search()

            return true
        }).catch(err => {
        });
    }
    displayCustomHTML() {
        const {useCustomHTML} = this.state.currentRecord;
        return <div className="top20 editor-wrapper ">
            <FormGroup>
                <Checkbox
                  onChange={(e) => {
                      const self = this;
                      this.setState({
                          'currentRecord': {
                              ...this.state.currentRecord,
                              useCustomHTML:!useCustomHTML,
                          }
                      }, ()=>{
                          if(self.state.currentRecord.useCustomHTML) {
                                  self.initializeCKeditor();
                                  self.setCkeditorValue(self.state.currentRecord.CustomHTML || '');
                          } else{
                              self.removeCKeditor();
                          }
                      });
                  }}
                  checked={useCustomHTML}><span className="top10">Display custom HTML</span></Checkbox>
            </FormGroup>
           {this.state.currentRecord.useCustomHTML &&
             <textarea name="editor"
                       style={{
                           width: '100%',
                       }} rows="10" defaultValue={''}></textarea>
           }

        </div>;
    }
    displayQualityChecksImages(){
       const {selectedImage = {},QualityCheckImages = []} = this.state.currentRecord
        const self = this;
       return  <Row className="left0 top20">
                <Col md={12} sm={12} xs={12} className="pleft0">
                    <ImageList
                      {...this.props}
                      currentRecord={this.state.currentRecord}
                      model={'quality_checks'}
                      deleteImage={(imageToDelete) => {
                          this.deleteImage(imageToDelete)
                          return Promise.resolve(true)
                      }}
                      doNotSaveImageInRecord={this.state.currentRecord.newRecordID ? true:false}
                      onImageSelect={(image) => {
                          if (selectedImage._id == image._id) {
                              image = {}
                          }
                          this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  selectedImage: image
                              }
                          })
                      }}
                      selectedImage={selectedImage}
                      uploadImagesSuccess={(uploadedImages) => {


                           this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  QualityCheckImages: uploadedImages
                              }
                          }, function () {
                                if(QualityCheckImages.length){
                                   self.deleteImage(QualityCheckImages[0], {doNotDisplayMessage:true})
                               }
                              if(QualityCheckImages.length == 0 && !this.state.currentRecord.newRecordID){
                                  this.search()
                              }

                          })
                      }}
                      images={QualityCheckImages}></ImageList>
                </Col>
            </Row>
    }
    render() {

        const {DeterministicQualityCheck = {}} = this.state.currentRecord;
        const {Choices = []} = DeterministicQualityCheck;

        return (
            <div >
                {_.size(this.state.allCategories) > 0 && _.size(this.state.allBrandsWithModels) > 0 &&
                <AdminQualityChecksSearchBox
                    ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                             this.searchBox = searchBox

                            this.search({page:this.state.currentPage+1})


                        }

                    }}
                    addNewRecord={this.addNewRecord.bind(this)}
                    //   onSelectAllRecordsChange={this.onSelectAllRecordsChange.bind(this)}
                    allCategories={this.state.allCategories}
                      allBrandsWithModels={this.state.allBrandsWithModels}
                    search={this.search.bind(this)}
                    {...this.props} ></AdminQualityChecksSearchBox>
                }
                <div className="clearfix"></div>
                {this.state.qualityChecks.fetched &&  _.size(this.state.allCategories) > 0 &&
                <div className="">
                    {this.state.qualityChecks.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">

                            <AdminQualityChecksListTable
                                 showRemoveDialog={(row)=>{
                                     this.setState({removeRecordModalVisible: true, currentRecord: row});}
                                 }
                                allCategories={this.state.allCategories}
                                 qualityChecks={this.state.qualityChecks.data}
                                onSortChange={this.onSortChange.bind(this)}
                                 editRecord={this.editRecord.bind(this)}
                                 currentPage={this.state.currentPage}
                                search={this.search.bind(this)} {...this.props}  ></AdminQualityChecksListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}

                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={  this.state.qualityChecks.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal className="custom-modal-dialog" onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >

                            <FormGroup>
                                <ControlLabel>Categories</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    clearable={false}
                                    multi
                                    placeholder=""
                                    valueRenderer={this.renderCategoriesValue.bind(this)}
                                    removeSelected={false}
                                    options={this.state.currentRecordCategoriesList}
                                    onChange={(options) => this.onCategoryFormChange(options)}
                                    value={this.state.currentRecord.Categories}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Subcategory</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    disabled={_.size(_.get(this.state.currentRecord, ['Categories'], [])) == 0}
                                    clearable={false}
                                    placeholder=""
                                    options={this.state.currentRecordSubcategoriesList}
                                    onChange={(option) => this.onSubcategoryFormChange(option)}
                                    value={this.state.Subcategory}
                                />
                            </FormGroup>


                            <FormGroup>
                                <ControlLabel>Category Tags</ControlLabel>
                                <CreatableSelect
                                    tabIndex="0"
                                    clearable={true}
                                    options={this.state.allCategoryTags}
                                    multi
                                    placeholder="Category Tags"
                                    removeSelected={false}
                                    //options={this.state.currentRecordCategoriesList}
                                    onChange={ (selectedOptions)=> {
                                        this.setState({
                                            currentRecord:{
                                                ...this.state.currentRecord,
                                                'CategoryTags': selectedOptions
                                            }
                                        })

                                    }}
                                    value={this.state.currentRecord.CategoryTags}
                                />
                            </FormGroup>

                            <FormGroup>
                            <ControlLabel>Brands and Models</ControlLabel>
                            <Select
                            tabIndex="0"
                            clearable={false}
                            multi
                            placeholder=""
                            valueRenderer={(option)=>{
                            return (
                            <div>
                            <div>{option.Brand}</div>
                            <div>{option.Model}</div>
                            </div>
                            );}
                            }
                            removeSelected={false}
                            options={this.state.allBrandsWithModels}
                            onChange={(options) => this.onBrandFormChange(options)}
                            value={this.state.currentRecord.Models}
                            />
                            </FormGroup>
                            <FormGroup>
                            <ControlLabel>Model</ControlLabel>
                            <Select
                            tabIndex="0"
                            disabled={_.size(_.get(this.state.currentRecord, ['Models'], [])) == 0}
                            clearable={false}
                            placeholder=""
                            options={this.state.currentRecordModelsList}
                            onChange={(option) => this.onModelFormChange(option)}
                            value={this.state.Model}
                            />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    placeholder="Status"

                                    clearable={false}
                                    options={  [{value: 'Active', label: 'Active'}, {value: 'Inactive', label: 'Inactive'}]}
                                    onChange={(option) => {
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                Status: option.value,
                                            }
                                        });
                                    }}
                                    value={this.state.currentRecord.Status}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Matching Type</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    placeholder="Type"
                                    clearable={false}
                                    options={  [{value: 'Matching', label: 'Matching'}, {value: 'GBGProductNotFound', label: 'GBG Product Not Found'}]}
                                    onChange={(option) => {
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                MatchingType: option.value,
                                            }
                                        });
                                    }}
                                    value={this.state.currentRecord.MatchingType}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Seller Rules (leave empty to match all)</ControlLabel>
                                <Select

                                    multi
                                    placeholder=""
                                    clearable={false}
                                    options={  config.inventoryOwnershipMap}

                                    onChange={(selectedOptions) => {
                                        var dataToUpdate ={
                                            ...this.state.currentRecord,
                                            SellerInventoryOwnership: selectedOptions,
                                        }
                                        if (selectedOptions.length==0){
                                            dataToUpdate.OverrideMatchingConditions =false
                                        }
                                        this.setState({
                                            'currentRecord': dataToUpdate
                                        });
                                    }}
                                    value={this.state.currentRecord.SellerInventoryOwnership}
                                />
                                <FormGroup>
                                    <Checkbox
                                        onChange={(e) =>  {
                                            this.setState({
                                                'currentRecord': {
                                                    ...this.state.currentRecord,
                                                    SearchCPSC:!_.get(this.state.currentRecord,'SearchCPSC',false)
                                                }
                                            });
                                        }}
                                        checked={_.get(this.state.currentRecord,'SearchCPSC',false)}  ><span className="top10">Search CPSC</span></Checkbox>

                            </FormGroup>
                            <Checkbox
                                onChange={(e) =>  {
                                    this.setState({
                                        'currentRecord': {
                                            ...this.state.currentRecord,
                                            OverrideMatchingConditions:!_.get(this.state.currentRecord,'OverrideMatchingConditions',false)
                                        }
                                    });
                                }}
                                checked={_.get(this.state.currentRecord,'OverrideMatchingConditions',false)}  ><span className="top10">Always show for selected seller types</span></Checkbox>

                        </FormGroup>
                            {Choices.length == 0 &&
                              <FormGroup>
                                  <ControlLabel>Answers</ControlLabel>
                                  <QualityCheckAnswerList
                                    displayMessage={this.props.displayMessage}
                                     updateState={data => this.setState(data)}
                                     currentRecord={this.state.currentRecord}>
                                   </QualityCheckAnswerList>
                                  <div className="clearfix"></div>
                              </FormGroup>
                            }
                            {Choices.length > 0 &&
                              <FormGroup>
                                  <ControlLabel>Flaws List</ControlLabel>
                                  <CreatableSelect
                                    clearable={true}
                                    multi
                                    onChange={(options) =>{
                                        if(options.length == 0) {
                                            return;
                                        }

                                        this.setState({
                                            currentRecord:{
                                                ...this.state.currentRecord,
                                                DeterministicQualityCheck:{
                                                    ...DeterministicQualityCheck,
                                                    Choices: options.map(item => item.label)
                                                }
                                            }
                                        });}
                                    }
                                    value={Choices.map(item=>{
                                    return {value:item, label:item};
                                    })}
                                  />
                              </FormGroup>
                            }
                            {DeterministicQualityCheck.Type !== config.deterministicQualityCheckTypes.Base &&
                              <FormGroup>
                                  <Checkbox
                                    onChange={(e) => {
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                DeterministicQualityCheck: {
                                                    ...DeterministicQualityCheck,
                                                    Type: DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.ShowFirst ? undefined : config.deterministicQualityCheckTypes.ShowFirst
                                                }
                                            }
                                        });
                                    }}
                                    checked={DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.ShowFirst}><span className="top10">Show first</span></Checkbox>
                              </FormGroup>
                            }
                            <FormGroup>
                                <Checkbox
                                    onChange={() => {
                                        const { IsSerialNumber: isSerialNumber = false } = this.state.currentRecord;
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                IsSerialNumber: !isSerialNumber
                                            }
                                        })
                                    }}
                                    checked={_.get(this.state.currentRecord, 'IsSerialNumber', false)}>
                                    <span className="top10">Is Serial Number?</span>
                                </Checkbox>
                            </FormGroup>
                            {this.displayCustomHTML()}
                            <FormGroup>
                                <ControlLabel>Rules</ControlLabel>
                                <FormControl componentClass="textarea" rows="4"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Rules: e.target.value
                                                 }
                                             })}
                                             value={_.isObject(this.state.currentRecord.Rules) ? JSON.stringify(this.state.currentRecord.Rules) : this.state.currentRecord.Rules }
                                             placeholder=" "/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Text</ControlLabel>
                                <FormControl type="text"
                                             componentClass="textarea"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Text: e.target.value
                                                 }
                                             })}

                                             value={this.state.currentRecord.Text }
                                             placeholder="Text"/>
                            </FormGroup>
                            <FormGroup>
                            {this.displayQualityChecksImages()}
                            </FormGroup>


                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.removeRecord() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>

            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
      };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(AdminQualityChecksPage));
